var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "../Base";
var BookmarkFill = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({}, props, { viewBox: "0 0 10 16" }),
        React.createElement("path", { transform: "translate(-758.000000, -1080.000000)", d: "M766.777778,1096 C766.555556,1096 766.333333,1096 766.222222,1095.89809 L763,1094.16561 L759.777778,1095.79618 C759.333333,1096 758.777778,1096 758.333333,1095.59236 C758.111111,1095.38854 758,1095.0828 758,1094.77707 L758,1080.50955 C758,1080.20382 758.222222,1080 758.555556,1080 L767.444444,1080 C767.777778,1080 768,1080.20382 768,1080.50955 L768,1094.77707 C768,1095.49045 767.444444,1096 766.777778,1096 Z" })));
};
export default BookmarkFill;
